import keyBy from 'lodash/keyBy';
import slice from 'lodash/slice';
import find from 'lodash/find';
import sortBy from 'lodash/sortBy';
import filter from 'lodash/filter';

import { getGreatCircleDistance } from './geography';

export interface StateInfo {
  name: string;
  slug: string;
  abbreviation: string;
  rank: number;
  minAge: number;
  latitude: number;
  longitude: number;
}

/**
 * Latitude and longitude is found from google public data.
 * https://developers.google.com/public-data/docs/canonical/states_csv
 */
export const states: StateInfo[] = [
  {
    name: 'Alabama',
    slug: 'alabama',
    abbreviation: 'AL',
    rank: 27,
    minAge: 16,
    latitude: 32.318231,
    longitude: -86.902298,
  },
  {
    name: 'Alaska',
    abbreviation: 'AK',
    rank: 48,
    minAge: 16,
    latitude: 63.588753,
    longitude: -154.493062,
    slug: 'alaska',
  },
  {
    name: 'Arizona',
    abbreviation: 'AZ',
    rank: 21,
    minAge: 16,
    latitude: 34.048928,
    longitude: -111.093731,
    slug: 'arizona',
  },
  {
    name: 'Arkansas',
    abbreviation: 'AR',
    rank: 35,
    minAge: 16,
    latitude: 35.20105,
    longitude: -91.831833,
    slug: 'arkansas',
  },
  {
    name: 'California',
    abbreviation: 'CA',
    rank: 1,
    minAge: 16,
    latitude: 36.778261,
    longitude: -119.417932,
    slug: 'california',
  },
  {
    name: 'Colorado',
    abbreviation: 'CO',
    rank: 19,
    minAge: 16,
    latitude: 39.550051,
    longitude: -105.782067,
    slug: 'colorado',
  },
  {
    name: 'Connecticut',
    abbreviation: 'CT',
    rank: 23,
    minAge: 16,
    latitude: 41.603221,
    longitude: -73.087749,
    slug: 'connecticut',
  },
  {
    name: 'Delaware',
    abbreviation: 'DE',
    rank: 43,
    minAge: 16,
    latitude: 38.910832,
    longitude: -75.52767,
    slug: 'delaware',
  },
  {
    name: 'District Of Columbia',
    abbreviation: 'DC',
    rank: 34,
    minAge: 16,
    latitude: 38.905985,
    longitude: -77.033418,
    slug: 'district-of-columbia',
  },
  {
    name: 'Florida',
    abbreviation: 'FL',
    rank: 4,
    minAge: 16,
    latitude: 27.664827,
    longitude: -81.515754,
    slug: 'florida',
  },
  {
    name: 'Georgia',
    abbreviation: 'GA',
    rank: 9,
    minAge: 16,
    latitude: 32.157435,
    longitude: -82.907123,
    slug: 'georgia',
  },
  {
    name: 'Hawaii',
    abbreviation: 'HI',
    rank: 40,
    minAge: 16,
    latitude: 19.898682,
    longitude: -155.665857,
    slug: 'hawaii',
  },
  {
    name: 'Idaho',
    abbreviation: 'ID',
    rank: 44,
    minAge: 16,
    latitude: 44.068202,
    longitude: -114.742041,
    slug: 'idaho',
  },
  {
    name: 'Illinois',
    abbreviation: 'IL',
    rank: 5,
    minAge: 16,
    latitude: 40.633125,
    longitude: -89.398528,
    slug: 'illinois',
  },
  {
    name: 'Indiana',
    abbreviation: 'IN',
    rank: 16,
    minAge: 16,
    latitude: 40.551217,
    longitude: -85.602364,
    slug: 'indiana',
  },
  {
    name: 'Iowa',
    abbreviation: 'IA',
    rank: 29,
    minAge: 16,
    latitude: 41.878003,
    longitude: -93.097702,
    slug: 'iowa',
  },
  {
    name: 'Kansas',
    abbreviation: 'KS',
    rank: 32,
    minAge: 16,
    latitude: 39.011902,
    longitude: -98.484246,
    slug: 'kansas',
  },
  {
    name: 'Kentucky',
    abbreviation: 'KY',
    rank: 28,
    minAge: 16,
    latitude: 37.839333,
    longitude: -84.270018,
    slug: 'kentucky',
  },
  {
    name: 'Louisiana',
    abbreviation: 'LA',
    rank: 24,
    minAge: 16,
    latitude: 31.244823,
    longitude: -92.145024,
    slug: 'louisiana',
  },
  {
    name: 'Maine',
    abbreviation: 'ME',
    rank: 45,
    minAge: 16,
    latitude: 45.253783,
    longitude: -69.445469,
    slug: 'maine',
  },
  {
    name: 'Maryland',
    abbreviation: 'MD',
    rank: 15,
    minAge: 16,
    latitude: 39.045755,
    longitude: -76.641271,
    slug: 'maryland',
  },
  {
    name: 'Massachusetts',
    abbreviation: 'MA',
    rank: 11,
    minAge: 16,
    latitude: 42.407211,
    longitude: -71.382437,
    slug: 'massachusetts',
  },
  {
    name: 'Michigan',
    abbreviation: 'MI',
    rank: 13,
    minAge: 16,
    latitude: 44.314844,
    longitude: -85.602364,
    slug: 'michigan',
  },
  {
    name: 'Minnesota',
    abbreviation: 'MN',
    rank: 17,
    minAge: 16,
    latitude: 46.729553,
    longitude: -94.6859,
    slug: 'minnesota',
  },
  {
    name: 'Mississippi',
    abbreviation: 'MS',
    rank: 37,
    minAge: 16,
    latitude: 32.354668,
    longitude: -89.398528,
    slug: 'mississippi',
  },
  {
    name: 'Missouri',
    abbreviation: 'MO',
    rank: 22,
    minAge: 16,
    latitude: 37.964253,
    longitude: -91.831833,
    slug: 'missouri',
  },
  {
    name: 'Montana',
    abbreviation: 'MT',
    rank: 50,
    minAge: 16,
    latitude: 46.879682,
    longitude: -110.362566,
    slug: 'montana',
  },
  {
    name: 'Nebraska',
    abbreviation: 'NE',
    rank: 36,
    minAge: 16,
    latitude: 41.492537,
    longitude: -99.901813,
    slug: 'nebraska',
  },
  {
    name: 'Nevada',
    abbreviation: 'NV',
    rank: 33,
    minAge: 16,
    latitude: 38.80261,
    longitude: -116.419389,
    slug: 'nevada',
  },
  {
    name: 'New Hampshire',
    abbreviation: 'NH',
    rank: 41,
    minAge: 16,
    latitude: 43.193852,
    longitude: -71.572395,
    slug: 'new-hampshire',
  },
  {
    name: 'New Jersey',
    abbreviation: 'NJ',
    rank: 0,
    minAge: 17,
    latitude: 40.058324,
    longitude: -74.405661,
    slug: 'new-jersey',
  },
  {
    name: 'New Mexico',
    abbreviation: 'NM',
    rank: 39,
    minAge: 16,
    latitude: 34.97273,
    longitude: -105.032363,
    slug: 'new-mexico',
  },
  {
    name: 'New York',
    abbreviation: 'NY',
    rank: 3,
    minAge: 16,
    latitude: 43.299428,
    longitude: -74.217933,
    slug: 'new-york',
  },
  {
    name: 'North Carolina',
    abbreviation: 'NC',
    rank: 10,
    minAge: 16,
    latitude: 35.759573,
    longitude: -79.0193,
    slug: 'north-carolina',
  },
  {
    name: 'North Dakota',
    abbreviation: 'ND',
    rank: 47,
    minAge: 15,
    latitude: 47.551493,
    longitude: -101.002012,
    slug: 'north-dakota',
  },
  {
    name: 'Ohio',
    abbreviation: 'OH',
    rank: 7,
    minAge: 16,
    latitude: 40.417287,
    longitude: -82.907123,
    slug: 'ohio',
  },
  {
    name: 'Oklahoma',
    abbreviation: 'OK',
    rank: 30,
    minAge: 16,
    latitude: 35.007752,
    longitude: -97.092877,
    slug: 'oklahoma',
  },
  {
    name: 'Oregon',
    abbreviation: 'OR',
    rank: 25,
    minAge: 16,
    latitude: 43.804133,
    longitude: -120.554201,
    slug: 'oregon',
  },
  {
    name: 'Pennsylvania',
    abbreviation: 'PA',
    rank: 6,
    minAge: 16,
    latitude: 41.203322,
    longitude: -77.194525,
    slug: 'pennsylvania',
  },
  {
    name: 'Rhode Island',
    abbreviation: 'RI',
    rank: 46,
    minAge: 16,
    latitude: 41.580095,
    longitude: -71.477429,
    slug: 'rhode-island',
  },
  {
    name: 'South Carolina',
    abbreviation: 'SC',
    rank: 26,
    minAge: 15,
    latitude: 33.836081,
    longitude: -81.163725,
    slug: 'south-carolina',
  },
  {
    name: 'South Dakota',
    abbreviation: 'SD',
    rank: 49,
    minAge: 14,
    latitude: 43.969515,
    longitude: -99.901813,
    slug: 'south-dakota',
  },
  {
    name: 'Tennessee',
    abbreviation: 'TN',
    rank: 18,
    minAge: 16,
    latitude: 35.517491,
    longitude: -86.580447,
    slug: 'tennessee',
  },
  {
    name: 'Texas',
    abbreviation: 'TX',
    rank: 2,
    minAge: 16,
    latitude: 31.968599,
    longitude: -99.901813,
    slug: 'texas',
  },
  {
    name: 'Utah',
    abbreviation: 'UT',
    rank: 31,
    minAge: 16,
    latitude: 39.32098,
    longitude: -111.093731,
    slug: 'utah',
  },
  {
    name: 'Vermont',
    abbreviation: 'VT',
    rank: 52,
    minAge: 16,
    latitude: 44.558803,
    longitude: -72.577841,
    slug: 'vermont',
  },
  {
    name: 'Virginia',
    abbreviation: 'VA',
    rank: 12,
    minAge: 16,
    latitude: 37.431573,
    longitude: -78.656894,
    slug: 'virginia',
  },
  {
    name: 'Washington',
    abbreviation: 'WA',
    rank: 14,
    minAge: 16,
    latitude: 47.751074,
    longitude: -120.740139,
    slug: 'washington',
  },
  {
    name: 'West Virginia',
    abbreviation: 'WV',
    rank: 42,
    minAge: 16,
    latitude: 38.597626,
    longitude: -80.454903,
    slug: 'west-virginia',
  },
  {
    name: 'Wisconsin',
    abbreviation: 'WI',
    rank: 20,
    minAge: 16,
    latitude: 43.78444,
    longitude: -88.787868,
    slug: 'wisconsin',
  },
  {
    name: 'Wyoming',
    abbreviation: 'WY',
    rank: 51,
    minAge: 16,
    latitude: 43.075968,
    longitude: -107.290284,
    slug: 'wyoming',
  },
];

export const cheapStates = filter(states, ({ abbreviation }) => abbreviation !== 'DC');

export type StateNameAbbr = (typeof states)[number]['abbreviation'];

export const stateAbbrMap = keyBy(states, 'abbreviation');

/**
 * Get nearest N states of given state.
 * @param stateNameOrAbbreviation - default to South Dakota, geo center of USA.
 * @param count
 */
export const getNearbyStates = (stateNameOrAbbreviation = 'SD', count: number): StateInfo[] => {
  const foundState = find(
    states,
    ({ name, abbreviation }) =>
      name.toLowerCase() === stateNameOrAbbreviation.toLowerCase() ||
      abbreviation.toLowerCase() === stateNameOrAbbreviation.toLowerCase()
  );

  if (!foundState) return [];

  const statesSortByDistance = sortBy(states, ({ latitude, longitude }) =>
    getGreatCircleDistance(foundState.latitude, foundState.longitude, latitude, longitude)
  );

  // The nearest one is the state itself, should remove.
  return slice(statesSortByDistance, 1, count + 1);
};

/**
 * Get state abbreviation from state name.
 * @param stateName
 * @returns
 */
export const getStateAbbreviation = (stateName?: string): string | undefined => {
  if (stateName) {
    const foundState = find(
      states,
      (state) =>
        state.abbreviation.toUpperCase() === stateName.toUpperCase() ||
        state.name.toUpperCase() === stateName.toUpperCase()
    );
    if (foundState) {
      return foundState.abbreviation;
    }
  }
  return stateName;
};
